import { render, staticRenderFns } from "./grant.vue?vue&type=template&id=ef037172&"
import script from "./grant.vue?vue&type=script&lang=js&"
export * from "./grant.vue?vue&type=script&lang=js&"
import style0 from "./grant.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports